import React from 'react';
import { useUI } from '../contexts/UIProvider';
import { useNavigation } from '../contexts/NavigationProvider';
import SparklesIcon from './icons/SparklesIcon';
import CloseIcon from './icons/CloseIcon';
import CheckIcon from './icons/CheckIcon';

const UpgradeModal: React.FC = () => {
    const { isUpgradeModalOpen, upgradeModalContent, closeUpgradeModal } = useUI();
    const { handleNavigation } = useNavigation();

    if (!isUpgradeModalOpen || !upgradeModalContent) return null;

    const handleUpgradeClick = () => {
        closeUpgradeModal();
        handleNavigation('pumpUpTheVolume');
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div 
                className="absolute inset-0 bg-black/80 backdrop-blur-sm"
                onClick={closeUpgradeModal}
            ></div>
            <div className="relative w-full max-w-md bg-brand-surface rounded-2xl shadow-2xl border border-brand-orange/50 overflow-hidden transform transition-all scale-100">
                {/* Header Graphic */}
                <div className="bg-gradient-to-r from-brand-orange to-red-600 p-6 text-center relative overflow-hidden">
                    <div className="absolute top-0 left-0 w-full h-full opacity-20 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]"></div>
                    <SparklesIcon className="h-16 w-16 text-white mx-auto relative z-10 animate-pulse" />
                    <h2 className="text-2xl font-bold text-white mt-4 relative z-10">{upgradeModalContent.title}</h2>
                    <button 
                        onClick={closeUpgradeModal}
                        className="absolute top-4 right-4 text-white/80 hover:text-white bg-black/20 rounded-full p-1"
                    >
                        <CloseIcon className="h-6 w-6" />
                    </button>
                </div>

                {/* Content */}
                <div className="p-8 text-center">
                    <p className="text-gray-300 text-lg mb-8 leading-relaxed">
                        {upgradeModalContent.description}
                    </p>

                    <div className="space-y-3 mb-8 text-left bg-gray-800/50 p-4 rounded-xl">
                        <div className="flex items-center text-sm text-gray-300">
                            <CheckIcon className="h-5 w-5 text-green-400 mr-2 flex-shrink-0" />
                            <span>Unlocks Unlimited Posts & Chats</span>
                        </div>
                        <div className="flex items-center text-sm text-gray-300">
                            <CheckIcon className="h-5 w-5 text-green-400 mr-2 flex-shrink-0" />
                            <span>Get the Pro Badge & Visibility</span>
                        </div>
                        <div className="flex items-center text-sm text-gray-300">
                            <CheckIcon className="h-5 w-5 text-green-400 mr-2 flex-shrink-0" />
                            <span>Save money compared to Pay-As-You-Go</span>
                        </div>
                    </div>

                    <button
                        onClick={handleUpgradeClick}
                        className="w-full bg-brand-orange text-white font-bold py-4 px-6 rounded-full text-lg shadow-lg hover:opacity-90 transition-transform hover:scale-105"
                    >
                        {upgradeModalContent.ctaText || "View Pro Plans"}
                    </button>
                    
                    <button
                        onClick={closeUpgradeModal}
                        className="mt-4 text-brand-muted hover:text-white text-sm font-semibold"
                    >
                        Maybe Later
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UpgradeModal;